import { FileIcon, Upload } from 'lucide-react';
import { Button } from '../../../../ui/button';
import type { BaseFieldProps, FileFieldSchema } from '../../../types';

export function FileFieldInput({
  field: _field,
  value: _value,
  onChange: _onChange,
  onUploadFile: _onUploadFile,
  onGetFile: _onGetFile,
  onRenameFile: _onRenameFile,
  error,
}: BaseFieldProps<FileFieldSchema, number | number[] | null | undefined>) {
  // Logic for file upload handling would go here
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Button variant="outline" className="w-full" onClick={() => {}}>
          <Upload className="w-4 h-4 mr-2" />
          Upload File
        </Button>
      </div>
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}

export function FileFieldView({
  field: _field,
  value,
  onGetFile: _onGetFile,
}: BaseFieldProps<FileFieldSchema, number | number[] | null | undefined>) {
  if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
    return <span className="text-muted-foreground text-sm">No files uploaded</span>;
  }

  const fileIds = Array.isArray(value) ? value : [value];

  return (
    <div className="flex flex-col gap-2">
      {fileIds.map((id) => (
        <div key={id} className="flex items-center gap-2 p-2 bg-muted/50 rounded-md">
          <FileIcon className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm font-medium">File ID: {id}</span>
        </div>
      ))}
    </div>
  );
}
